<template>
  <div :class="computedClass">
    <div class="mb-4">
      <span class="font-bold">Processamento Manual</span>
      <div class="flex flex-row gap-4 flex-wrap items-start">
        <v-select
          v-model="action"
          :options="actions"
          label="label"
          value="value"
          placeholder="Selecionar Ação"
          :reduce="(item) => item.value"
          style="width: 320px"
        ></v-select>
        <div class="flex flex-row gap-4">
          <flat-pickr
            v-show="action === STAR_MANUAL_ACTIONS.CANCEL.value"
            class="input-data-cancelamento w-full sm:mb-0 mb-3"
            name="Data de cancelamento"
            id="Data de cancelamento"
            data-testid="cancelation-date"
            v-model="cancellationDate"
            style="width: 200px"
            :config="getConfigDatePicker()"
            placeholder="Data de cancelamento"
          />
        </div>
        <v-select
          v-if="shouldShowPaidInstallments"
          v-model="selectedPaidInstallment"
          :options="paidInstallmentOptions"
          label="label"
          value="value"
          placeholder="Selecionar Parcela"
          :reduce="(item) => item.value"
          style="width: 320px"
        ></v-select>
        <vs-button
          color="primary"
          type="border"
          :disabled="
            !action ||
            (action === STAR_MANUAL_ACTIONS.CANCEL.value &&
              !cancellationDate) ||
            (action === STAR_MANUAL_ACTIONS.DOWN.value &&
              !selectedPaidInstallment)
          "
          @click="executeManualAction"
          class="font-bold"
          >Executar</vs-button
        >
        <vs-button
          icon="refresh"
          @click="reloadData"
          color="primary"
          type="border"
        />
      </div>
    </div>
    <vs-collapse type="border" class="star-logs-collapse">
      <vs-collapse-item v-for="(item, index) in logs" :key="item.id || index">
        <div class="flex flex-row gap-4 items-center" slot="header">
          <span class="font-bold mr-4">{{ defineAcao(item.action) }}</span>
          <vs-chip class="mr-3" :color="defineCorChip(item.status)">
            {{ defineStatus(item.status) }}
          </vs-chip>
        </div>
        <div class="flex flex-row gap-4 flex-wrap justify-start mb-3">
          <div class="flex flex-col w-1/4">
            <span class="font-bold">Data de sincronização: </span>
            <span>{{ functions.formatDateAndHour(item.syncDate) }}</span>
          </div>
          <div class="flex flex-col w-1/6">
            <span class="font-bold">Tentativas: </span>
            <span>{{ item.tries }} </span>
          </div>
          <div class="flex flex-col w-1/4">
            <span class="font-bold">Data do Cancelamento: </span>
            <span>{{
              item.cancellationDate
                ? functions.formataDataMomentJS(
                    item.cancellationDate,
                    'DD/MM/YYYY',
                    3,
                  )
                : 'Não se aplica'
            }}</span>
          </div>
          <div class="flex flex-col w-48">
            <span class="font-bold">Status: </span>
            <vs-chip class="mr-3" :color="defineCorChip(item.status)">
              {{ defineStatus(item.status) }}
            </vs-chip>
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <span class="font-bold">Arquivo: </span>
          <vs-button
            radius
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-download"
            @click="downloadFile(item.url)"
          ></vs-button>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import vSelect from 'vue-select';

import { STAR_MANUAL_ACTIONS, TIPOS_APOLICES } from '@/utils/constants';
import moment from 'moment';
import flatPickr from 'vue-flatpickr-component';
import starApiService from '../../../../services/star.api';
import fileDownload from '../../../../utils/fileDownload';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import { formatResponsavel } from '../../../../utils/integrationHelpers';

export default {
  name: 'StarIntegrationContent',
  components: {
    vSelect,
    flatPickr,
  },
  props: ['logs', 'policy-id', 'policyType', 'paidData'],
  computed: {
    STAR_MANUAL_ACTIONS() {
      return STAR_MANUAL_ACTIONS;
    },
    computedClass() {
      const hasLogs = Array.isArray(this.logs) && this.logs.length === 0;
      return hasLogs ? 'pb-24' : 'pb-8';
    },
    actions() {
      if (this.policyType !== TIPOS_APOLICES.MICRO_VIDA) {
        return [STAR_MANUAL_ACTIONS.CREATE, STAR_MANUAL_ACTIONS.DOWN];
      }
      return [
        STAR_MANUAL_ACTIONS.CREATE,
        STAR_MANUAL_ACTIONS.CANCEL,
        STAR_MANUAL_ACTIONS.DOWN,
      ];
    },
    shouldShowPaidInstallments() {
      return this.action === STAR_MANUAL_ACTIONS.DOWN.value;
    },
    paidInstallments() {
      const data =
        this.paidData &&
        typeof this.paidData === 'object' &&
        !Array.isArray(this.paidData)
          ? this.paidData
          : {};
      const installments = Array.isArray(data.installments)
        ? data.installments
        : [];
      return installments
        .filter(
          (installment) =>
            installment &&
            installment.id !== undefined &&
            installment.id !== null &&
            !installment.deletedAt,
        )
        .map((installment) => ({
          id: Number(installment.id),
          paymentId: Number(installment.paymentId),
          paymentType: Number(installment.paymentType),
          installmentOrder: Number(
            String(installment.installmentNumber || '')
              .split('/')[0]
              .trim() || 0,
          ),
          paymentValue:
            installment.paymentAmount !== undefined &&
            installment.paymentValue !== null
              ? Number(installment.paymentValue)
              : installment.installmentValue !== undefined &&
                installment.installmentValue !== null
              ? Number(installment.installmentValue)
              : 0,
          deletedAt: installment.deletedAt,
        }));
    },
    paidInstallmentOptions() {
      if (!Array.isArray(this.paidInstallments)) {
        return [];
      }

      return this.paidInstallments
        .slice()
        .sort((a, b) => {
          const aNumber = Number(a.installmentOrder || 0);
          const bNumber = Number(b.installmentOrder || 0);
          return aNumber - bNumber;
        })
        .map((installment) => {
          const installmentNumber = installment.installmentOrder || '-';
          const value = Number(installment.paymentValue || 0);

          return {
            label: `Parcela ${installmentNumber} - ${
              this.functions.formataReal(value) || 'R$ 0,00'
            }`,
            value: {
              paymentId: installment.paymentId,
              installmentId: installment.id,
              paymentType: installment.paymentType,
            },
          };
        });
    },
  },
  data() {
    return {
      functions,
      action: null,
      cancellationDate: null,
      selectedPaidInstallment: null,
    };
  },
  methods: {
    formatResponsavel,
    defineStatus(status) {
      const colorsByStatus = {
        pending: 'Pendente',
        failed: 'Falha',
        done: 'Enviada',
      };
      return colorsByStatus[status];
    },
    defineCorChip(status) {
      const colorsByStatus = {
        pending: 'warning',
        failed: 'danger',
        done: 'success',
      };
      return colorsByStatus[status];
    },
    defineAcao(action) {
      const labelByAction = {
        create: 'Envio de apólice',
        down: 'Pagamento de parcela',
        cancel: 'Cancelamento',
      };
      return labelByAction[action];
    },
    async execute() {
      this.$vs.loading();
      const payload = {
        policyId: this.policyId,
        action: this.action,
      };

      if (this.action === STAR_MANUAL_ACTIONS.CANCEL.value) {
        payload.cancellationDate = moment(
          this.cancellationDate,
          'DD/MM/YYYY',
        ).toDate();
      }

      try {
        await starApiService.execute(payload);
        notify.notifySuccess(this.$vs, 'Registro processado com sucesso.');
        this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao processar registro.');
      } finally {
        this.$vs.loading.close();
      }
    },
    async executeDownInstallment() {
      if (!this.selectedPaidInstallment) {
        notify.notifyFail(this.$vs, 'Selecione uma parcela para processar.');
        return;
      }

      const paymentId = Number(this.selectedPaidInstallment.paymentId);
      const installmentId = Number(this.selectedPaidInstallment.installmentId);
      if (
        !Number.isFinite(paymentId) ||
        paymentId <= 0 ||
        !Number.isFinite(installmentId) ||
        installmentId <= 0
      ) {
        notify.notifyFail(
          this.$vs,
          'Parcela selecionada sem identificador de pagamento.',
        );
        return;
      }

      this.$vs.loading();
      try {
        await starApiService.executeDownInstallment({
          policyId: Number(this.policyId),
          paymentId,
          installmentId,
          paymentType: this.selectedPaidInstallment.paymentType,
        });
        notify.notifySuccess(this.$vs, 'Baixa enviada com sucesso.');
        this.action = null;
        this.selectedPaidInstallment = null;
        this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao processar baixa.');
      } finally {
        this.$vs.loading.close();
      }
    },
    async executeManualAction() {
      if (this.action === STAR_MANUAL_ACTIONS.DOWN.value) {
        await this.executeDownInstallment();
        return;
      }

      await this.execute();
    },
    async downloadFile(link) {
      fileDownload.download(window, link);
    },
    reloadData() {
      this.$emit('reload');
    },
    getConfigDatePicker() {
      return {
        ...functions.getConfigDateTimePickerDay(),
        maxDate: new Date(),
      };
    },
  },
  watch: {
    action(newValue) {
      if (newValue !== STAR_MANUAL_ACTIONS.DOWN.value) {
        this.selectedPaidInstallment = null;
      }
    },
  },
};
</script>

<style scoped>
.star-logs-collapse ::v-deep .vs-collapse-item--content > .con-content--item {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 1rem;
  box-sizing: border-box;
  scrollbar-gutter: stable;
}
</style>
